// Opzioni delle pagine admin condivise (AdminUsers, CompanyUsers, CompanyManagement).
// File di modulo (non sincronizzato): vedi kernelAdminShared.js per il significato.
const adminConfig = {
  deleteWarning: true,
};

export default adminConfig;
